import * as React from 'react';
import { Menu, Row, Col, Layout } from 'antd';
import { withRouter, RouteComponentProps } from "react-router-dom";
import { WithTranslation, withTranslation } from 'react-i18next';
import HttpService from 'src/core/services/http.service';
import i18next from 'i18next';

const { Content, Footer } = Layout



interface FooterProps extends WithTranslation, RouteComponentProps {
    footerLogo?: any
}

class FooterView extends React.Component<FooterProps> {
    public render() {
        const { t } = this.props

        return <Footer className={"login-footer"} >
            <div className={"fi-footer-logo"} ><img src={this.props.footerLogo} style={{ height: "50px" }} /></div>
            <div className={"login-footer-text"}>
                {t("Copyright")} {new Date().getFullYear()} {t("F.initiatives all rights reserved")} - <a href={"https://www.f-initiatives.com/mentions-legales/"} target="_blanck">{t("Terms of Use")}</a> -<a href={"https://www.f-initiatives.com/demarche-donnees-personnelles/"} target="_blanck">{t("Data Subject Right")}</a>  - <a href={"https://www.f-initiatives.com/politique-de-confidentialite-relative-au-site-fi-initiatives/"} target="_blank">{t("Cookies Policy")}</a>
            </div>
        </Footer>
    }
    getDataLink(): string | undefined {
        switch (i18next.language) {
            case "es":
                return "https://es.fi-group.com/politica-de-privacidad/"
            case "en":
                return "https://uk.fi-group.com/data-subject-right/"
            case "pt":
                return "https://pt.fi-group.com/direito-sobre-dados-pessoais/"
            case "pt-br":
                return "https://br.fi-group.com/politica-de-cookies/"
            case "fr":
                return "https://fr.fi-group.com/demarche-donnees-personnelles/"
            case "it":
                return "https://it.fi-group.com/diritto-individuale-ai-sensi-del-regolamento-generale-sulla-protezione-dei-dati/"
            case "de":
                return "https://de.fi-group.com/data-subject-right/"


        }
        return "https://es.fi-group.com/politica-de-privacidad/"
    }
    getCookiePolicyLink(): string | undefined {
        switch (i18next.language) {
            case "es":
                return "https://es.fi-group.com/politica-de-cookies/"
            case "en":
                return "https://uk.fi-group.com/fi-group-uk-referral-campaign/"
            case "pt":
                return "https://pt.fi-group.com/politica-de-privacidade/"
            case "pt-br":
                return "https://br.fi-group.com/politica-de-privacidade/"
            case "fr":
                return "https://fr.fi-group.com/politique-de-confidentialite-relative-au-site-fi-group/"
            case "it":
                return "https://it.fi-group.com/cookie-policy/"
            case "de":
                return "https://de.fi-group.com/cookie-declaration/"


        }
        return "https://es.fi-group.com/politica-de-cookies/"
    }

    getTermAndConditionLink(): string | undefined {
        switch (i18next.language) {
            case "es":
                return "https://es.fi-group.com/terminos-y-condiciones/"
            case "en":
                return "https://uk.fi-group.com/term-of-use/"
            case "pt":
                return "https://pt.fi-group.com/termos-de-uso/"
            case "pt-br":
                return "https://br.fi-group.com/termos-de-uso/"
            case "fr":
                return "https://fr.fi-group.com/mentions-legales/"
            case "it":
                return "https://it.fi-group.com/menzioni-legali/"
            case "de":
                return "https://de.fi-group.com/term-of-use/"


        }
        return "https://es.fi-group.com/terminos-y-condiciones/"
    }
}
export default withRouter(withTranslation()(FooterView))